import { NavigateFunction, NavigateOptions } from "react-router";

import { AxlClipboard } from "../axl-clipboard";

export class AppNavigatorLink {
  constructor(
    public relativeUrl: string,
    private navigateFn: NavigateFunction,
    // eslint-disable-next-line no-empty-function
  ) {}

  get originUrl() {
    return `${window.location.origin}${this.relativeUrl}`;
  }

  async copyToClipboard(origin = false) {
    const url = origin ? this.originUrl : this.relativeUrl;

    return AxlClipboard.copyText(url);
  }

  navigate(options?: NavigateOptions) {
    this.navigateFn(this.relativeUrl, options);
  }
}
